import { ImageControlComponent } from './iamge-control/iamge-control.component';
import { CropperDialogComponent } from './cropper-dialog/cropper-dialog.component';
import { ReviewPotentialInstructorsComponent } from './review-potential-instructors/review-potential-instructors.component';
import { FluidHeightDirective } from './../directives/fluid-height.directive';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';

import { UpcomingSessionsComponent } from './upcoming-sessions/upcoming-sessions.component';
import { WebLinksComponent } from './web-links/web-links.component';
import { SocialLinksComponent } from './social-links/social-links.component';
import { SkillAreasComponent } from './skill-areas/skill-areas.component'

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCardModule } from '@angular/material/card';
import {
  MatBottomSheetModule
} from '@angular/material/bottom-sheet';
import { MatSliderModule } from '@angular/material/slider';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AwardsAccoladesComponent } from './awards-accolades/awards-accolades.component';
import { InstructorStatsComponent } from './instructor-stats/instructor-stats.component';
import { InstructorSearchComponent } from './instructor-search/instructor-search.component';
import { LoadingComponent } from './loading/loading.component';
import { BarRatingModule } from "ngx-bar-rating";
import { AvailabilityCalendarComponent } from './availability-calendar/availability-calendar.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import { MatStepperModule } from '@angular/material/stepper';
import { LinkedinSigninComponent } from './linkedin-signin/linkedin-signin.component';
import { OnboardingComponent } from '../authentication/onboarding/onboarding.component';
import { StripeComponent } from './stripe/stripe.component';

import { MatProgressButtonsModule } from 'mat-progress-buttons';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { NgxStripeModule } from 'ngx-stripe';
import { WriteMessageComponent } from './write-message/write-message.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { InstructorNotesListComponent } from './instructor-notes-list/instructor-notes-list.component';
import { WriteInstructorNotesComponent } from './write-instructor-notes/write-instructor-notes.component';
import { InstructorNotesComponent } from './instructor-notes/instructor-notes.component';

import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSlideToggle, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { WelcomeModalComponent } from './welcome-modal/welcome-modal.component';
import { HeaderLessTabsDirective } from '../directives/headerless.tabs.directive';
import { NotificationComponentComponent } from './notification-component/notification-component.component';
import { InlineEditComponent } from './inline-edit/inline-edit.component';
//import { BdcWalkModule } from 'bdc-walkthrough';
import { AuthModalComponent } from './auth-modal/auth-modal.component';
import { TNCurrencyPipe } from './pipes/tn-currency-pipe';
import { TimezonePickerPipe } from './pipes/timezone-picker.pipe';
import { MinuteSecondsPipe } from './pipes/minute-seconds.pipe';
import { TimezonePickerComponent } from './timezone-picker/timezone-picker.component';
import { ProfileModalComponent } from './profile-modal/profile-modal.component';

import { InstuctorSocialsComponent } from './instuctor-socials/instuctor-socials.component';
import { CameraComponentComponent } from './camera-component/camera-component.component';
import { AvailabilityComponentComponent } from './availability-component/availability-component.component';
import { MatTableModule } from '@angular/material/table';
import { TwilioComponentComponent } from './twilio-component/twilio-component.component';
//import { AgoraComponentComponent } from './agora-component/agora-component.component';
import { CameraPreviewComponent } from './camera-preview/camera-preview.component';
import { InputOutputSettingsComponent } from './input-output-settings/input-output-settings.component';
import { SoundMeterComponent } from './sound-meter/sound-meter.component';
import { RoundTransparentIconButtonComponent } from './round-transparent-icon-button/round-transparent-icon-button.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MeetingControlsComponent } from './meeting-controls/meeting-controls.component';
import { MeetingParticipantControlsComponent } from './meeting-participant-controls/meeting-participant-controls.component';
import { MeetingParticipantComponent } from './meeting-participant/meeting-participant.component';
import { AgoraVideoPlayerDirective } from '../directives/agora-video-player.directive';
import { CountDownTimerComponent } from './countdown-timer/countdown-timer.component';
import { CoachingAvailabilityComponent } from './coaching-availability/coaching-availability.component';
import { QuestionaireModalComponent } from './questionaire-modal/questionaire-modal.component';
import { QuestionaireDropdownComponent } from './questionaire-modal/questionaire-dropdown/questionaire-dropdown.component';
import { QuestionaireRadioComponent } from './questionaire-modal/questionaire-radio/questionaire-radio.component';

import { NgxSpinnerModule } from 'ngx-spinner';
import { UserCommunicationsComponent } from './user-communications/user-communications.component';
import { MatSelectModule } from '@angular/material/select';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MatRadioModule } from '@angular/material/radio';
import { ClientListComponent } from './client-list/client-list.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    NgbModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    FullCalendarModule,
    MatIconModule,
    ReactiveFormsModule,
    MatBadgeModule,
    MatSlideToggleModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatBottomSheetModule,
    MatListModule,
    MatButtonToggleModule,
    MatSidenavModule,
    MatSnackBarModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatCardModule,
    MatRadioModule,
    MatSliderModule,
    MatSelectModule,
    MatTabsModule,
    MatCheckboxModule,
    NgbModule,
    MatMenuModule,
    MatStepperModule,
    MatDialogModule,
    BarRatingModule,
    NgxMaskDirective,
    NgxMaskPipe,
    ImageCropperModule,
    HttpClientModule,
    // BdcWalkModule,
    CKEditorModule,
    NgxStripeModule.forRoot('pk_test_9IMZgYNXTk6d1QKe48axpq9A00PUk9Rj23'),
    MatTableModule,
    FontAwesomeModule,
    NgbNavModule,
    NgxSpinnerModule,
    MatBottomSheetModule,
    MatProgressSpinnerModule
  ],
  exports: [UpcomingSessionsComponent,
    WebLinksComponent,
    InstructorSearchComponent,
    SocialLinksComponent,
    SkillAreasComponent,
    AwardsAccoladesComponent,
    InstructorStatsComponent,
    LinkedinSigninComponent,
    StripeComponent,
    LoadingComponent,
    WriteMessageComponent,
    InstructorNotesListComponent,
    WriteInstructorNotesComponent,
    InstructorNotesComponent,
    HeaderLessTabsDirective,
    AgoraVideoPlayerDirective,
    FluidHeightDirective,
    NotificationComponentComponent,
    InlineEditComponent,
    AuthModalComponent,
    TNCurrencyPipe,
    TimezonePickerPipe,
    MinuteSecondsPipe,
    InstuctorSocialsComponent,
    CameraComponentComponent,
    AvailabilityComponentComponent,
    //AgoraComponentComponent,
    TwilioComponentComponent,
    CameraPreviewComponent,
    InputOutputSettingsComponent,
    SoundMeterComponent,
    RoundTransparentIconButtonComponent,
    MeetingControlsComponent,
    MeetingParticipantControlsComponent,
    MeetingParticipantComponent,
    TimezonePickerComponent,
    CountDownTimerComponent,
    CoachingAvailabilityComponent,
    UserCommunicationsComponent,
    QuestionaireDropdownComponent,
    QuestionaireRadioComponent,
    ClientListComponent,
    ReviewPotentialInstructorsComponent,
    CropperDialogComponent,
    ImageControlComponent
  ],
  declarations: [
    UpcomingSessionsComponent,
    WebLinksComponent,
    InstructorSearchComponent,
    SocialLinksComponent,
    SkillAreasComponent,
    AwardsAccoladesComponent,
    InstructorStatsComponent,
    AvailabilityCalendarComponent,
    LinkedinSigninComponent,
    StripeComponent,
    LoadingComponent,
    WriteMessageComponent,
    InstructorNotesListComponent,
    WriteInstructorNotesComponent,
    InstructorNotesComponent,
    WelcomeModalComponent,
    HeaderLessTabsDirective,
    AgoraVideoPlayerDirective,
    FluidHeightDirective,
    NotificationComponentComponent,
    InlineEditComponent,
    AuthModalComponent,
    TNCurrencyPipe,
    TimezonePickerPipe,
    MinuteSecondsPipe,
    ProfileModalComponent,
    InstuctorSocialsComponent,
    CameraComponentComponent,
    AvailabilityComponentComponent,
    //AgoraComponentComponent,
    TwilioComponentComponent,
    CameraPreviewComponent,
    InputOutputSettingsComponent,
    SoundMeterComponent,
    RoundTransparentIconButtonComponent,
    MeetingControlsComponent,
    MeetingParticipantControlsComponent,
    MeetingParticipantComponent,
    TimezonePickerComponent,
    CountDownTimerComponent,
    CoachingAvailabilityComponent,
    QuestionaireModalComponent,
    UserCommunicationsComponent,
    QuestionaireDropdownComponent,
    QuestionaireRadioComponent,
    ClientListComponent,
    ReviewPotentialInstructorsComponent,
CropperDialogComponent,
ImageControlComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [{ provide: Window, useValue: window }, provideNgxMask()]
})
export class ComponentsModule { }
